if (!customElements.get("hull-color-options")) {
  class HullColorOptions extends HTMLElement {
    constructor() {
      super();
      this.onChange = this.onChange.bind(this);
      this.onBlockSelect = this.onBlockSelect.bind(this);
    }

    connectedCallback() {
      this.inputs = Array.from(this.querySelectorAll("[data-hull-color-input]"));
      this.panels = Array.from(this.querySelectorAll("[data-hull-color-panel]"));

      this.addEventListener("change", this.onChange);
      this.addEventListener("shopify:block:select", this.onBlockSelect);

      const selectedInput = this.inputs.find((input) => input.checked) || this.inputs[0];
      if (selectedInput) this.selectColor(selectedInput.value);
    }

    disconnectedCallback() {
      this.removeEventListener("change", this.onChange);
      this.removeEventListener("shopify:block:select", this.onBlockSelect);
    }

    onChange(event) {
      if (this.inputs.includes(event.target)) {
        this.selectColor(event.target.value);
      }
    }

    onBlockSelect(event) {
      const block = event.target.closest("[data-hull-color-block]");
      if (block && this.contains(block)) {
        this.selectColor(block.dataset.hullColorBlock);
      }
    }

    selectColor(blockId) {
      const selectedInput = this.inputs.find((input) => input.value === blockId);
      const selectedPanel = this.panels.find((panel) => panel.dataset.hullColorPanel === blockId);
      if (!selectedInput || !selectedPanel) return;

      this.inputs.forEach((input) => {
        input.checked = input === selectedInput;
      });

      this.panels.forEach((panel) => {
        panel.hidden = panel !== selectedPanel;
      });
    }
  }

  customElements.define("hull-color-options", HullColorOptions);
}
